import { CheckoutLoginOrContactInfoStep } from '../../EoeCheckout/steps/CheckoutLoginOrContactInfoStep.js';
import type { CheckoutStepProps } from '../FixedBroadbandCheckout.js';

export const StepLoginOrContactInfo = (props: CheckoutStepProps) => {
  const { enterNextStep } = props;

  return (
    <CheckoutLoginOrContactInfoStep
      onNext={() => {
        enterNextStep(2);
      }}
    />
  );
};
